import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 513D2CF1-31F5-4F3B-8543-2499ABB20924
 * name home-heart
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-heart.svg
 * tags
 * - Home Automation 
 * - People / Family 
 */
export const HomeHeartIcon = createSvgIcon(<><path d="M2,12L12,3L22,12H19V20H5V12H2M12,18L12.72,17.34C15.3,15 17,13.46 17,11.57C17,10.03 15.79,8.82 14.25,8.82C13.38,8.82 12.55,9.23 12,9.87C11.45,9.23 10.62,8.82 9.75,8.82C8.21,8.82 7,10.03 7,11.57C7,13.46 8.7,15 11.28,17.34L12,18Z" /></>, 'HomeHeartIcon');
export default HomeHeartIcon